<template>
  <p class="dal-paragraph">
    <span
      v-for="(word, wndex) in p.split(' ')"
      :key="wndex"
      class="word"
    >
      <span
        v-for="(letter, kndex) in word"
        :key="kndex"
        :class="spanClasses(letter)"
        :style="{
          'transition-delay': `${Math.ceil(Math.random() * 1500)}ms`
        }"
      >
        {{ letter }}
      </span>
    </span>
  </p>
</template>

<script>
import { doneMixin } from '@/mixins'

export default {
  name: 'DalParagraph',
  props: {
    p: {
      type: String,
      required: true
    }
  },
  mixins: [doneMixin],
  methods: {
    spanClasses (letter) {
      return {
        'span--active': this.done,
        'span': letter,
        'span--space': letter === ' ',
        'span--else': letter !== ' '
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dal-paragraph {
  color: white;
  line-height: 1.5;

  &:nth-child(4), &:nth-child(7), &:nth-child(11), &:nth-child(14) {
    margin-bottom: 200px;
  }
  &:last-child {
    color: $c-red;
  }
}
.word {
  display: inline-block;
  margin-left: 0.1em;
  margin-right: 0.1em;
}
.span {
  &--else {
    display: inline-block;
    transform: translateY(25px);
    opacity: 0;
    transition: all 3000ms cubic-bezier(.19,1,.22,1);
    transition-property: opacity, transform;
    will-change: opacity, transform;
  }
  &--active {
    transform: translateY(0px);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dal/DalParagraph.vue